import { Tabs, Row, Col } from "antd";
import EditableResponse from "../../../Components/EditableResponse";
import BlotterSnapshots from "./BlotterSnapshots";
import React from "react";

const BlotterResponse = ({response, data, closeResponse, extraDetails })=>{
    const onTabChange = (key) => {
        console.log(key);
        if (key === '0') {
            closeResponse?.();
        }
    }
    return (

        <Tabs defaultActiveKey="1" type={'card'} tabPosition={'left'} onChange={onTabChange}>
            <Tabs.TabPane key={'0'} tab={'Back to Chart'} />
            <Tabs.TabPane key={'1'} tab={'Talking Points'}>
                <Row justify={'center'}>
                    <Col xs={24} lg={18} >
                        <EditableResponse response={response} />
                    </Col>
                </Row>
            </Tabs.TabPane>
            <Tabs.TabPane key={'2'} tab={'Snapshots'}>
                <BlotterSnapshots data={data} extraDetails={extraDetails} />
            </Tabs.TabPane>
        </Tabs>

    )
}

export default BlotterResponse;
